<script>
  import { tick } from "svelte"
  import Chain from "./Chain.svelte"

  export let chains
</script>

<main class="mt-4 group">
  <div
    class="pl-4 mb-2 text-lg font-medium flex items-center justify-between border-l-4 border-success"
  >
    <a
      href="/chains"
      title="Open chains timeline"
      aria-label="Open chains timeline"
      >Chains
    </a>
  </div>
  {#each chains as chain (chain.id)}
    <Chain bind:chain />
  {/each}
</main>
